// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__x2s0b","tabActive":"styles_tabActive__VaKaf styles_tab__x2s0b"};